// src/firebase/firebase.js
import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC0BX-vuLmbE-ahphtGtbPrQaqjSxBiyNc",
  authDomain: "clearhealthemr.firebaseapp.com",
  projectId: "clearhealthemr",
  storageBucket: "clearhealthemr.firebasestorage.app",
  messagingSenderId: "587867313133",
  appId: "1:587867313133:web:5753c881b3fdd30bdccde4"
};

const app = initializeApp(firebaseConfig);

/**
 * Firestore (persistent cache)
 * - persistentLocalCache() is the modern replacement for enableIndexedDbPersistence
 * - persistentMultipleTabManager() helps when multiple tabs are open
 */
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

const auth = getAuth(app);
const functions = getFunctions(app); // ✅ callable Cloud Functions

/* ---------------------------------------------
   OPTIONAL: Emulator support (only in dev)
   Uncomment if you use emulators.
---------------------------------------------- */
// import { connectAuthEmulator } from "firebase/auth";
// import { connectFirestoreEmulator } from "firebase/firestore";
// import { connectFunctionsEmulator } from "firebase/functions";

// if (window.location.hostname === "localhost") {
//   connectAuthEmulator(auth, "http://localhost:9099");
//   connectFirestoreEmulator(db, "localhost", 8080);
//   connectFunctionsEmulator(functions, "localhost", 5001);
// }

export { app, db, auth, functions };
export default app;
